import { render, staticRenderFns } from "./VFormItemDisableSwitch.vue?vue&type=template&id=ca199942&"
import script from "./VFormItemDisableSwitch.vue?vue&type=script&lang=js&"
export * from "./VFormItemDisableSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca199942')) {
      api.createRecord('ca199942', component.options)
    } else {
      api.reload('ca199942', component.options)
    }
    module.hot.accept("./VFormItemDisableSwitch.vue?vue&type=template&id=ca199942&", function () {
      api.rerender('ca199942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VFormItemDisableSwitch.vue"
export default component.exports